/**
 * @generated SignedSource<<3b7847c218fdd00dcc687d528ee6592a>>
 * @relayHash 15f6230dde25ecca0c41e7953e0cbdda
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fdaef7b3c57581fed82d75ce10ba791c7d75eeeb5daa295dbe681eeacbcf4cfb

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraDevOpsIssuePanelBannerType = "ISSUE_KEY_ONBOARDING" | "%future added value";
export type OnboardingMessageMutation$variables = {
  bannerType: JiraDevOpsIssuePanelBannerType;
  issueId: string;
};
export type OnboardingMessageMutation$data = {
  readonly jira: {
    readonly devOps: {
      readonly dismissDevOpsIssuePanelBanner: {
        readonly errors: ReadonlyArray<{
          readonly extensions: {
            readonly __typename: "GenericMutationErrorExtension";
            readonly statusCode: number | null | undefined;
          } | {
            // This will never be '%other', but we need some
            // value in case none of the concrete values match.
            readonly __typename: "%other";
          } | null | undefined;
          readonly message: string | null | undefined;
        }> | null | undefined;
        readonly success: boolean;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type OnboardingMessageMutation = {
  response: OnboardingMessageMutation$data;
  variables: OnboardingMessageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "bannerType"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueId"
},
v2 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "bannerType",
        "variableName": "bannerType"
      },
      {
        "kind": "Variable",
        "name": "issueId",
        "variableName": "issueId"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "success"
},
v4 = {
  "kind": "ScalarField",
  "name": "message"
},
v5 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "statusCode"
    }
  ],
  "type": "GenericMutationErrorExtension"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "OnboardingMessageMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraDevOpsMutation",
            "kind": "LinkedField",
            "name": "devOps",
            "plural": false,
            "selections": [
              {
                "args": (v2/*: any*/),
                "concreteType": "JiraDismissDevOpsIssuePanelBannerPayload",
                "kind": "LinkedField",
                "name": "dismissDevOpsIssuePanelBanner",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "extensions",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v6/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "OnboardingMessageMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraDevOpsMutation",
            "kind": "LinkedField",
            "name": "devOps",
            "plural": false,
            "selections": [
              {
                "args": (v2/*: any*/),
                "concreteType": "JiraDismissDevOpsIssuePanelBannerPayload",
                "kind": "LinkedField",
                "name": "dismissDevOpsIssuePanelBanner",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "extensions",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v6/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "id"
                              }
                            ],
                            "type": "BulkMutationErrorExtension"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "fdaef7b3c57581fed82d75ce10ba791c7d75eeeb5daa295dbe681eeacbcf4cfb",
    "metadata": {},
    "name": "OnboardingMessageMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "5233c2ef7f2348c4e5630943c7660d1a";

export default node;
